import React from "react";
import { Card, CardBody, Collapse } from "reactstrap";

const data = {
  title: `
    <p>The meta title should clearly describe the page content, include the primary keyword, and ideally feature your brand name within 50-60 characters.</p>
        
    <p>Examples:</p>
    <ul class="mb-0">
      <li><strong>Bad:</strong> Party Rentals, Obstacle Courses, Bounce Houses, Fun Activities, Event Supplies, Games</li>
      <li><strong>Good:</strong> Dinosaur Bouncy Castle - Best Bouncy Castle Hire service in Manchester</li>
    </ul>
  `,
  
  description: `
    <p>The meta description should provide an engaging summary of the page's content, include the primary keyword, and encourage users to click, all within 150-160 characters.</p>
        
    <p>Examples:</p>
    <ul class="mb-0">
      <li><strong>Bad:</strong> We offer different types of obstacle courses. Visit our site to see what we have available. Great for all events.</li>
      <li><strong>Good:</strong> Dinosaur Bouncy Castle is one of the wide range of products available from Bounce with Us events experts. Contact us today!</li>
    </ul>
  `,
  
  keywords: `
    <p>The meta keywords should include relevant keywords that describe the page content, separated by commas. While not as important for SEO as they once were, they can still provide context for the page.</p>
    
    <p>Examples:</p>
    <ul class="mb-0">
      <li><strong>Bad:</strong> bouncy castle, party rentals, event supplies, games, fun activities</li>
      <li><strong>Good:</strong> bouncy castle, dinosaur bouncy castle, party rentals, event supplies, games, fun activities</li>
    </ul>
  `,
  
  indx: `
    <p>Index this page in search engines to allow it to appear in search results. This is typically set to "yes" unless you want to prevent the page from being indexed.</p>
  `
};
function Hint({ type }: { type: 'title' | 'description' | 'keywords' | 'index' }) {
  const [col5, setCol5] = React.useState(false);
  const t_col5 = () => {
    setCol5((prev) => !prev);
  };
  const getHelpText = () => {
    if (type === 'title') return data.title;
    if (type === 'description') return data.description;
    if (type === 'keywords') return data.keywords;
    if (type === 'index') return data.indx;
    return '';
  };
  return (
    <>
      <button
        onClick={t_col5}
        className="btn p-0 m-0"
        type="button"
        style={{ cursor: "pointer" }}
      >
        <i className="mdi mdi-information-outline py-0 m-0 px-1 font-size-16 text-primary"></i>
      </button>
      <Collapse isOpen={col5} className="pb-0 mb-0">
        <Card className='mb-0 p-0 shadow-none'>
            <CardBody dangerouslySetInnerHTML={{ __html: getHelpText() }} className="px-0 pb-0"/>
        </Card>
      </Collapse> 
    </>
  );
}

export default Hint;
